import { Control, Controller, ControllerProps, useFormContext } from 'react-hook-form';
import TextField, { OutlinedTextFieldProps } from '@mui/material/TextField';
import { InputAdornment, Typography } from '@mui/material';

export interface FormInputProps extends Omit<ControllerProps, 'name' | 'control' | 'render'> {
    name: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    control?: Control<any, any>;
    label?: string;
    textFieldProps?: Partial<OutlinedTextFieldProps>;
}

// Handles money input
export default function FormInputMoney({
    name,
    control,
    label,
    textFieldProps,
    ...rest
}: FormInputProps) {
    const { trigger } = useFormContext();
    return (
        <Controller
            {...rest}
            name={name}
            control={control}
            render={({ field: { onChange, value, ...restField }, fieldState: { error } }) => (
                <TextField
                    slotProps={{
                        input: {
                            // default to showing a dollar sign
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                        },
                    }}
                    {...textFieldProps}
                    {...restField}
                    helperText={
                        error?.message ? (
                            <Typography color="error" variant="caption">
                                {error?.message}
                            </Typography>
                        ) : null
                    }
                    // size="small"
                    error={!!error}
                    onChange={(e) => {
                        // Only save digits and dots, limit to 2 decimal places
                        e.target.value = e.target.value
                            // this regex removes all but digits and dots, ensures only one dot
                            .replace(/[^0-9.]+|(\..*)\./g, '')
                            // limits to 2 decimal places
                            .replace(/(\.\d{2}).*$/, '$1')
                            // this regex removes any leading 0s before numbers or any leading dots - dots must be preceded by a number
                            .replace(/^0+(?=\d)|^0+(?=\d)/g, '');

                        onChange(e);
                        // triggering Yup validation on change
                        trigger?.(name);
                    }}
                    value={value}
                    fullWidth
                    label={label}
                    margin="dense"
                    variant="outlined"
                />
            )}
        />
    );
}
